import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { executeDisbusement } from '@/data/api/request/disbursementsRequests';
import { ENG_TO_ESP_MONTH } from '@/utils/constants';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useExecuteDisbursement() {
  const queryClient = useQueryClient();
  const { showSnackError, showSnackSuccess } = useSnackbarContext();

  const executeDisbursementMutation = useMutation({
    mutationFn: (amount: number) =>
      executeDisbusement({
        description: formatMagicPayString(new Date()),
        amount: amount,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.disbursement.balance],
      });
      showSnackSuccess('Dispersión realizada');
    },
    onError: () => showSnackError('Error al realizar dispersión'),
  });

  const formatMagicPayString = (date: Date) => {
    const englishMonth = date.toLocaleString('en-US', { month: 'long' }); // "June"
    const spanishMonth =
      ENG_TO_ESP_MONTH[englishMonth as keyof typeof ENG_TO_ESP_MONTH];
    const day = date.getDate();

    return `${day} de ${spanishMonth} - SPEI from MagicPay`;
  };

  return {
    executeDisbusement: executeDisbursementMutation.mutate,
  };
}
